import { useEffect } from 'react'

import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";

// Hooks

import GetWindowSize from '../../hooks/GetWindowSize';

// Services

import { handleResetFormSteps } from '../../store/forms/forms.actions';
import {
  clearInsertClientInBackOfficeStore,
  clearUploadClientFilesToBackOfficeStore
} from '../../store/clients/clients.actions';

// Components

import Button from '../../components/UI/Button/Button';

// Images

import icnSuccess from './Images/icn-success.png';
import btnAppStore from './Images/btn-app-store.png';
import btnGooglePlay from './Images/btn-google-play.png';
import imgSmartPhoneLine from './Images/img-smartphone-line.png';
import imgSmartPhone from './Images/img-smartphone.jpg';

// Constants

import { APP_STORE_URL, OFFICES_URL, PLAY_STORE_URL } from '../../config/constants';

// Styles

import './Styles.scss';

export default function Success() {
  const { state } = useLocation();
  const navigate = useNavigate();

  // Hooks
  const { windowSize } = GetWindowSize();

  const dispatch = useDispatch();

  useEffect(() => {
    if (state?.formCompleted) {
      dispatch(handleResetFormSteps());
      dispatch(clearInsertClientInBackOfficeStore());
      dispatch(clearUploadClientFilesToBackOfficeStore());
      localStorage.removeItem("clientEmail");
      localStorage.removeItem('clientPhone');
    } else {
      navigate('/', { replace: true });
    }
  }, [state, navigate, dispatch]);

  return (
    <div className='page-wrapper success-page'>

      {/* Success Message */}

      <div className='container'>

        <div className='success-message'>

          <img src={icnSuccess} alt='' />

          <h1>¡Tu nueva cuenta te está esperando!</h1>

          <h2>Agradecemos que hayas comenzado el proceso de Solicitud de tu(s) Cuenta(s) con nosotros. Para finalizar, te invitamos a visitar la agencia Bancaribe de tu preferencia. Recuerda llevar los documentos requeridos en los próximos 30 días continuos para completar el proceso.

            <br />
            <br />
            Estamos comprometidos en ofrecerte una experiencia ágil y satisfactoria
            <br />
            ¡Esperamos verte pronto y darte la bienvenida a la familia Bancaribe!
          </h2>

        </div>

      </div>


      {/* Affiliate Invitation */}

      <div className='success-affiliate'>

        <div className='container'>

          <div className='success-affiliate-details'>

            <div className='success-affiliate-message'>

              <h2>Consulta nuestras oficinas</h2>

            </div>

            <div className='success-affiliate-action'>

              <Button
                type="button"
                action={() => window.open(OFFICES_URL)}
                additionalStyles={windowSize?.innerWidth >= 769 ? { width: '70%', fontSize: '1.25rem', margin: 0 } : { margin: 0 }}
                label={'Oficinas Operativas'}
              />

            </div>

          </div>

        </div>

      </div>


      {/* Download Mobile App */}

      <div className='container'>

        <div className='success-mobile-app'>

          <div className="success-mobile-app-download">

            <h4>Conoce nuestra App</h4>

            <p>Porque sabemos que tu tiempo es oro, gestiona tus finanzas desde donde estés. Disfruta de todas las bondades que te ofrece Mi Conexión Bancaribe Digital en cualquier lugar, desde tu smartphone. Recuerda, debes completar la apertura a través de una de nuestras oficinas para poder registrarte.</p>

            <p>Queremos acompañarte a donde lo necesites.</p>

            <div className="success-mobile-app-download-links">
              <ul>
                <li>
                  <a href={APP_STORE_URL} rel="noopener noreferrer" target="_blank">
                    <img src={btnAppStore} alt="Descargar en App Store para iOS" /></a>
                </li>
                <li>
                  <a href={PLAY_STORE_URL} rel="noopener noreferrer" target="_blank">
                    <img src={btnGooglePlay} alt="Descargar en Google Play para Android" />
                  </a>
                </li>
              </ul>

            </div>

            <img className='success-mobile-app-line' src={imgSmartPhoneLine} alt="" />

          </div>

          <div className="success-mobile-app-image">

            <img src={imgSmartPhone} alt="" />

          </div>

        </div>

      </div>

    </div>
  )
}
